import {Component, input, computed} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslocoPipe} from '@jsverse/transloco';
import {Panel} from 'primeng/panel';
import {HrSystemRecordingCardComponent} from '../../../shared/components/hr-system-recording-card/hr-system-recording-card.component';
import {ModuleFunction} from '@frontend/directus';
import {OfficeModule} from '@frontend/shared';

@Component({
  selector: 'app-office-system-accordion',
  imports: [CommonModule, TranslocoPipe, Panel, HrSystemRecordingCardComponent],
  templateUrl: './office-system-accordion.component.html',
})
export class OfficeSystemAccordionComponent {
  readonly moduleFunctions = input.required<ModuleFunction[]>();
  readonly officeModule = input.required<OfficeModule>();
  readonly isFirst = input(false);

  protected readonly moduleSystemRecording = computed(
    () => this.officeModule().moduleSystemRecordings,
  );
  protected readonly moduleSystemRecordingCount = computed(
    () => this.moduleSystemRecording().length,
  );
}
